import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { memberEndpoint } from '@/services/members/member-endpoint';

interface UpdateMemberRoleProps {
  organizationId?: string;
  inviteId?: string;
  email: string;
  role: string;
  is_infra_admin?: boolean;
}

export const updateMemberRole = async ({
  organizationId,
  inviteId,
  email,
  role,
  is_infra_admin,
}: UpdateMemberRoleProps) => {
  const orgId = organizationId || useOrgStore.getState().currentOrg?.orgid;

  const body: Record<string, unknown> = { role };
  if (is_infra_admin !== undefined) {
    body.is_infra_admin = is_infra_admin;
  }

  const result = await apiRequest({
    url: memberEndpoint(orgId, { inviteId, email }),
    target: 'platform',
    method: 'PATCH',
    body,
  });

  if (result?.detail) {
    return { detail: result.detail || 'Failed to update member role' };
  }

  return result;
};
